import type { ReactNode } from "react";

interface DownloadListWorkspaceProps {
  /** Title, filters, and other chrome that stays fixed while the table scrolls. */
  pinned: ReactNode;
  /** Scrollable table panel (rows only). */
  table: ReactNode;
  /** Cursor pager fixed below the scroll region, above export footer. */
  pager?: ReactNode;
  /** Export ZIP bar fixed below the pager. Omit for inline export in toolbar. */
  footer?: ReactNode;
}

/**
 * Fixed viewport layout for Download list pages: filters pinned, table panel scrolls.
 */
export function DownloadListWorkspace({
  pinned,
  table,
  pager,
  footer,
}: DownloadListWorkspaceProps) {
  return (
    <div className="download-list-workspace">
      <div className="download-list-workspace-pinned">{pinned}</div>
      <div className="download-list-workspace-scroll">{table}</div>
      {pager ? (
        <div className="download-list-workspace-pager shrink-0">{pager}</div>
      ) : null}
      {footer ? (
        <div className="download-list-workspace-footer shrink-0">{footer}</div>
      ) : null}
    </div>
  );
}
